import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = ["checkbox"];
  static values = { url: String, id: Number };

  toggleState(event) {
    const isChecked = event.target.checked;
    const originalState = !isChecked; // Save the original state in case of failure
    const tdElement = this.element; // The parent `<td>` element

    fetch(this.urlValue, {
      method: "PATCH",
      headers: {
        "Content-Type": "application/json",
        "X-CSRF-Token": document.querySelector('meta[name="csrf-token"]').content,
      },
      body: JSON.stringify({ receives_notifications: isChecked }),
    })
      .then((response) => {
        if (!response.ok) {
          throw new Error("Network response was not ok");
        }
        return response.json();
      })
      .then((data) => {
        console.log("State updated successfully:", data);
        this.pulseBackground(tdElement, "bg-success"); // Apply success feedback
      })
      .catch((error) => {
        console.error("Error updating state:", error);
        event.target.checked = originalState; // Revert checkbox state
        this.pulseBackground(tdElement, "bg-danger"); // Apply failure feedback
      });
  }

  pulseBackground(element, colorClass) {
    element.classList.add(colorClass, "transition-background");
    // Add the fade effect after a slight delay
    setTimeout(() => {
      element.classList.add("bg-fade");
      setTimeout(() => {
        element.classList.remove(colorClass, "bg-fade", "transition-background");
      }, 1500); // Ensure fade-out completes before removing the class
    }, 1500); // Delay before starting the fade-out
  }
}
